/**
 * Pure damage/formula helpers (integer math only) — unit-tested in damage.test.ts.
 * Formulas from docs/00 + docs/03; numbers come from config.
 */

/** physical/magical mitigation: taken = raw * K / (def + K), floored */
export function mitigate(raw: number, def: number, K: number): number {
  return Math.floor((raw * K) / (def + K))
}

/** weapon hit before crit/mitigation: base * (1 + AD/100), floored */
export function weaponBaseDamage(base: number, ad: number): number {
  return Math.floor((base * (100 + ad)) / 100)
}

/** apply an additive percent bonus (e.g. affinity +10%) */
export function applyPctBonus(value: number, pct: number): number {
  return Math.floor((value * (100 + pct)) / 100)
}

/** crit chance overflow above 100% becomes bonus crit damage (Option B, docs/03) */
export function effectiveCrit(critChancePct: number, critMultiplierPct: number): { chancePct: number; damagePct: number } {
  return {
    chancePct: Math.min(100, critChancePct),
    damagePct: critMultiplierPct + Math.max(0, critChancePct - 100),
  }
}

/** attack interval: charBase * weaponSpeed%, sped up by attack-speed bonus %, min 1 tick */
export function attackIntervalTicks(baseTicks: number, weaponSpeedPct: number, attackSpeedBonusPct: number): number {
  return Math.max(1, Math.floor((baseTicks * weaponSpeedPct) / (100 + attackSpeedBonusPct)))
}
